export default __webpack_public_path__ + "static/media/compass.683cbd57.svg";